<template lang="pug">
  api-form(
    v-model="value"
    :fields="fields"
    :method="save"
    v-bind="$attrs"
  )
</template>

<script>
import HintWrap from '@/components/HintWrap.vue';

export default {
  name: 'UnitForm',
  props: {
    courseId: { type: Number, default: null },
    moduleId: { type: Number, default: null },
    order: { type: Number, default: null },
  },
  data: () => ({
    value: {},
    fields: [
      {
        text: 'Наименование',
        value: 'title',
        rules: 'required',
        component: 'v-text-field',
        component_attrs: {
          filled: true,
          rounded: true,
        },
      },
      {
        text: 'Описание',
        value: 'description',
        component: 'v-textarea',
        component_attrs: {
          filled: true,
          rounded: true,
        },
      },
      {
        text: 'Продолжительность обучения',
        value: 'duration',
        rules: 'required',
        component: HintWrap,
        component_attrs: {
          component: 'v-text-field',
          hintDescription: 'Указывается в академических часах',
          filled: true,
          rounded: true,
          type: 'number',
        },
      },
    ],
  }),
  methods: {
    save({ data, obs }) {
      const payloads = { ...data };
      if (this.courseId) {
        payloads.course_id = this.courseId;
        payloads.ordinal = this.order;
      } else if (this.moduleId) {
        payloads.course_module_ids = [{ id: this.moduleId, sort_order: this.order }];
      }
      return this.$api.courseUnits.create(payloads, obs);
    },
  },
};
</script>
